import React from 'react';
import { IconProps } from '../types';

const LogoutIcon = ({ width = '16px', height = '21px', color }: IconProps) => {
  return (
    <svg
      width={width}
      height={height}
      fill={color}
      viewBox="0 0 16 21"
      version="1.1"
    >
      <g
        id="Symbols"
        stroke="none"
        strokeWidth="1"
        fill="none"
        fillRule="evenodd"
      >
        <g
          id="Sidebar"
          transform="translate(-25.000000, -482.000000)"
          fill="#CECECE"
          fillRule="nonzero"
        >
          <g id="Menu-Icons" transform="translate(-5.000000, 58.000000)">
            <g id="Logout" transform="translate(30.000000, 424.000000)">
              <path
                d="M8,16 C9.1,16 10,15.1 10,14 C10,12.9 9.1,12 8,12 C6.9,12 6,12.9 6,14 C6,15.1 6.9,16 8,16 L8,16 Z M14,7 L13,7 L13,5 C13,2.2 10.8,0 8,0 C5.2,0 3,2.2 3,5 L4.9,5 C4.9,3.3 6.3,1.9 8,1.9 C9.7,1.9 11.1,3.3 11.1,5 L11.1,7 L2,7 C0.9,7 0,7.9 0,9 L0,19 C0,20.1 0.9,21 2,21 L14,21 C15.1,21 16,20.1 16,19 L16,9 C16,7.9 15.1,7 14,7 L14,7 Z M14,19 L2,19 L2,9 L14,9 L14,19 L14,19 Z"
                id="Shape"
              ></path>
            </g>
          </g>
        </g>
      </g>
    </svg>
  );
};

export default LogoutIcon;
